import { extendTheme } from '@chakra-ui/react'
import { GlobalStyleProps, mode } from '@chakra-ui/theme-tools'

import { Badge } from './components/badge'
import { Button } from './components/button'
import { Card } from './components/card'
import { Checkbox } from './components/checkbox'
import { Divider } from './components/divider'
import {
  FormError,
  FormLabel,
  Input,
  Select,
  Textarea,
} from './components/form'
import { Heading } from './components/heading'
import { IconBadge } from './components/iconBadge'
import { Modal } from './components/modal'
import { Pagination } from './components/pagination'
import { PhoneNumberInput } from './components/phoneNumberInput'
import { Popover } from './components/popover'
import { Radio, RadioGroup } from './components/radio'
import { Switch } from './components/switch'
import { Tabs } from './components/tabs'
import { Tag } from './components/tag'
import { Text } from './components/text'
import { Tooltip } from './components/tooltip'
import { breakpoints } from './foundations/breakpoints'
import { colors } from './foundations/colors'
import { shadows } from './foundations/shadows'
import {
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
  textStyles,
} from './foundations/typography'

export * from './types'

const theme = extendTheme({
  breakpoints,
  colors,
  components: {
    Badge,
    Button,
    Card,
    Checkbox,
    Divider,
    FormError,
    FormLabel,
    Heading,
    IconBadge,
    Input,
    Modal,
    Pagination,
    PhoneNumberInput,
    Popover,
    Radio,
    RadioGroup,
    Select,
    Switch,
    Tabs,
    Tag,
    Text,
    Textarea,
    Tooltip,
  },
  direction: 'ltr',
  fontSizes,
  fontWeights,
  fonts,
  letterSpacings,
  lineHeights,
  radii: {
    md: '0px',
  },
  shadows,
  styles: {
    global: (props: GlobalStyleProps) => ({
      '*, *::before, &::after': {
        borderColor: mode('neutral.20', 'whiteAlpha.300')(props),
      },
    }),
  },
  textStyles,
})

export default theme
